import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {CustomFieldModel} from "../../../site-preferences/models/custom-field.model";
import {SettingsService} from "../../../site-preferences/services/settings-service.service";

export class omsViewSettingsPanelCtrl implements IController {

  settings: any;
  onSettingsChange: Function;

  public packageCustomFields: CustomFieldModel[] = [];

  /* @ngInject */
  constructor(private $mdPanel,
              private settingsService: SettingsService,
              private splitService: SplitService) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = angular.copy(this.settings);

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<oms-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings"></oms-settings-panel-template>',
      controller: function() {
        this.settings = settingsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess:(panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    const settingsConfig = this.splitService.getSiteOmsSettings(this.splitService.getSiteId());
    this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.oms')
  .component('omsViewSettingsPanel', {
    bindings: {
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./oms-view-settings-panel.html').default,
    controller: omsViewSettingsPanelCtrl
  });
